import React from "react";
import {
    FaXTwitter,
    FaInstagram,
    FaFacebookF,
    FaTelegram,
    FaTiktok,
    FaDiscord,
} from "react-icons/fa6";

export const SOCIAL_DEFS = [
    { key: "twitter", label: "Twitter / X", Icon: FaXTwitter, placeholder: "https://x.com/yourhandle" },
    { key: "instagram", label: "Instagram", Icon: FaInstagram, placeholder: "https://instagram.com/yourhandle" },
    { key: "facebook", label: "Facebook", Icon: FaFacebookF, placeholder: "https://facebook.com/yourpage" },
    { key: "telegram", label: "Telegram", Icon: FaTelegram, placeholder: "https://t.me/yourchannel" },
    { key: "tiktok", label: "TikTok", Icon: FaTiktok, placeholder: "https://tiktok.com/@yourhandle" },
    { key: "discord", label: "Discord", Icon: FaDiscord, placeholder: "https://discord.gg/invite" },
];

export function SocialIcons({ socials, size = "md" }) {
    if (!socials) return null;
    const sizes = {
        sm: "w-9 h-9 text-sm",
        md: "w-10 h-10 text-base",
        lg: "w-12 h-12 text-lg",
    };
    return (
        <div className="flex flex-wrap gap-2">
            {SOCIAL_DEFS.map(({ key, label, Icon }) => {
                const url = socials[key];
                const enabled = !!url;
                return (
                    <a
                        key={key}
                        data-testid={`social-${key}`}
                        href={enabled ? url : undefined}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={label}
                        title={label}
                        className={`${sizes[size]} flex items-center justify-center border border-white/15 transition-colors ${
                            enabled
                                ? "text-white hover:text-frost hover:border-frost"
                                : "text-slate-700 border-white/5 pointer-events-none"
                        }`}
                    >
                        <Icon />
                    </a>
                );
            })}
        </div>
    );
}
